import Choices from "choices.js";

export function StyledSelect(selector, options = {}) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => {
    new Choices(element, {
      noResultsText: 'Nie znaleziono wyników',
      noChoicesText: 'Brak możliwości wyboru',
      itemSelectText: 'Naciśnij aby wybrać',
      searchPlaceholderValue: 'Wyszukaj...',
      paste: false,
      shouldSortItems: false,
      shouldSort: false,
      ...options
    });
  });
}

// StyledSelect();

const inlineSelectConfig = {
  searchEnabled: false,
  classNames: {
    containerOuter: 'choices choices--inline'
  }
}

const inlineProductSelect = {
  searchEnabled: false,
}
StyledSelect('.js-select-inline', inlineSelectConfig);

StyledSelect('.wpcf7-select', inlineProductSelect);

StyledSelect('.js-sample-switch', {
  searchEnabled: false,
  itemSelectText: '',
});



const inlineSelectConfig1 = {
  searchEnabled: false,
  classNames: {
    containerOuter: 'choices choices--inline'
  }
}
// StyledSelect('.area', {
//   choices: [{
//     value: 'Option 1',
//     label: 'Option 1',
//     selected: true,
//     disabled: false,
//   },
//   {
//     value: 'Option 2',
//     label: 'Option 2',
//     selected: false,
//     disabled: true,
//     customProperties: {
//       description: 'Custom description about Option 2',
//       random: 'Another random custom property'
//     },
//   }],
//   itemSelectText: '',
// });

// const element = document.querySelector('.area');
// const area = new Choices(element, {
//   noResultsText: 'Nie znaleziono wyników',
//       noChoicesText: 'Brak możliwości wyboru',
//       itemSelectText: 'Naciśnij aby wybrać',
//       searchPlaceholderValue: 'Wyszukaj...',
//       paste: false,
//       shouldSortItems: false,
//       shouldSort: false,
//       placeholder: true,
//       placeholderValue: 'Wybierz strefę',
// });
